class DimensionFilterReactTranslations {
    constructor() {
        this.property = '';
        this.condition = '';
        this.value = '';
    }
}
export default DimensionFilterReactTranslations;
